var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#EDAD0C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2051 19.952L25 23.7469L23.7468 25L19.9519 21.2051C18.5874 22.2968 16.857 22.9498 14.9749 22.9498C10.5727 22.9498 6.99997 19.3771 6.99997 14.9749C6.99997 10.5728 10.5727 7 14.9749 7C19.377 7 22.9498 10.5728 22.9498 14.9749C22.9498 16.857 22.2967 18.5875 21.2051 19.952ZM19.4273 19.2945C20.5108 18.1778 21.1776 16.6546 21.1776 14.9749C21.1776 11.5479 18.4019 8.7722 14.9749 8.7722C11.5479 8.7722 8.77217 11.5479 8.77217 14.9749C8.77217 18.4019 11.5479 21.1776 14.9749 21.1776C16.6546 21.1776 18.1778 20.5108 19.2944 19.4273L19.4273 19.2945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.ba24945a8c7448bbebe11104783f8f2f.svg";
export { ForwardRef as ReactComponent };